<template src="./Details.html">
</template>

<script>
export default {
        props: {
            itemId: {
                type: Number,
                required: true,
            },
        },

        created() {
            this.$store
                .dispatch("employees/getDetails", this.itemId)
                .then(() => {

                })
                .catch(() => { });
        },
  computed: {
    employee() {
          return this.$store.state.employees.employee;
      }
  },
};
</script>